import { getToken as getTokenOriginal } from '@unowmooc/utils/auth'
import Cookies from 'js-cookie'

/**
 * Wrapper autour de getToken qui vérifie d'abord le cookie LMS
 * Si le cookie lms-auth-token existe, on l'utilise
 * Sinon, on utilise le getToken standard
 */
export const getToken = () => {
  const lmsToken = Cookies.get('lms-auth-token')
  if (lmsToken) {
    return { token: lmsToken, isFromLms: true }
  }
  return { token: getTokenOriginal(), isFromLms: false }
}
